import React from 'react'
import { createContext } from 'lib/createContext'
import { useVndlyIssuesFiltersQueryState } from '../hooks/useVndlyIssuesFiltersQueryState'
import { useVndlyInstancesQuery } from 'queries/admin/vndly/useVndlyInstancesQuery'
import { VndlyInstance } from 'api/admin/vndly/listVndlyInstances'

type VndlyIssuesContextState = {
  state: {
    instances: VndlyInstance[]
    filters: {
      instanceIds: number[] | null
      companyIds: number[] | null
    }
  }
  actions: {
    setFilters: ReturnType<typeof useVndlyIssuesFiltersQueryState>[1]
  }
}

const [Context, useVndlyIssuesContextValue] =
  createContext<VndlyIssuesContextState>({
    name: 'VndlyIssuesContext',
  })

export const VndlyIssuesProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { data: instances } = useVndlyInstancesQuery()

  const [filters, setFilters] = useVndlyIssuesFiltersQueryState()

  const value = {
    state: {
      instances: instances?.items ?? [],
      filters,
    },
    actions: {
      setFilters,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useVndlyIssuesContextValue }
